import React, { useState } from 'react';
import PersonalInfo from './components/PersonalInfo';
import ProjectsSection from './components/ProjectsSection';
import MouseLight from './components/MouseLight';
import ImageModal from './components/ImageModal';

function App() {
  const [modalImage, setModalImage] = useState<{ src: string; alt: string } | null>(null);

  return (
    <div className="min-h-screen bg-[#0a192f] relative">
      {/* Mouse Light Effect - только для desktop */}
      <MouseLight />
      
      {/* Desktop Layout */}
      <div className="hidden lg:flex relative z-10">
        {/* Fixed Left Panel */}
        <div className="fixed left-0 top-0 w-1/2 h-screen bg-transparent z-10">
          <div className="h-full bg-[#0a192f]/80 backdrop-blur-sm">
            <PersonalInfo />
          </div>
        </div>
        
        {/* Right Panel with Projects */}
        <div className="ml-auto w-1/2 bg-transparent">
          <div className="h-full bg-[#0a192f]/80 backdrop-blur-sm">
            <ProjectsSection onImageClick={setModalImage} />
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="lg:hidden">
        <div className="bg-[#0a192f]">
          <PersonalInfo />
        </div>
        <div className="bg-[#0a192f]">
          <ProjectsSection onImageClick={setModalImage} />
        </div>
      </div>

      {/* Модальное окно для просмотра изображений */}
      <ImageModal
        isOpen={modalImage !== null}
        imageSrc={modalImage?.src || ""}
        imageAlt={modalImage?.alt || ""}
        onClose={() => setModalImage(null)}
      />
    </div>
  );
}

export default App; 